import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import withLocalization from '~/hoc/withLocalization';
import GenericList from '~/components/GenericList/GenericList';
import { shortDateFormat, dateToTimeFormat } from '~/utils/dateFormat';

class TwoFactorHistoryList extends Component {
    setUserLocation(location_info) {
        let locationData = '';
        if (location_info.city) locationData = locationData.concat(location_info.city);
        if (location_info.regionName) locationData = locationData.concat(', ', location_info.regionName);
        if (location_info.country) locationData = locationData.concat(', ', location_info.country);
        if (location_info.zip) locationData = locationData.concat(', ', location_info.zip);

        return (
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{locationData}</Tooltip>}>
                <span>{locationData}</span>
            </OverlayTrigger>
        );
    }

    render() {
        const { t, userStore, commonStore, userId } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();

        return (
            <GenericList
                columns={[
                    {
                        Header: 'Date',
                        id: 'created_at_date',
                        accessor: ({ history_created_at }) => (
                            <span>{shortDateFormat(history_created_at, dateTimeRules)}</span>
                        ),
                        minWidth: 60,
                        maxWidth: 60,
                        textAlign: 'start',
                    },
                    {
                        Header: 'Time',
                        id: 'created_at_time',
                        accessor: ({ history_created_at }) => (
                            <span>{dateToTimeFormat(history_created_at, dateTimeRules)}</span>
                        ),
                        minWidth: 50,
                        maxWidth: 50,
                        textAlign: 'start',
                    },
                    {
                        Header: 'Action By',
                        accessor: 'action_by_name',
                        id: 'action_by_name',
                        minWidth: 80,
                        maxWidth: 80,
                        textAlign: 'start',
                    },
                    {
                        Header: 'Action',
                        id: 'action',
                        minWidth: 100,
                        maxWidth: 100,
                        textAlign: 'start',
                        accessor: ({ action }) => (
                            <span>{t(action)}</span>
                        ),
                    },
                    {
                        Header: 'Reason',
                        accessor: 'comment',
                        id: 'comment',
                        minWidth: 150,
                        textAlign: 'start',
                    },
                    {
                        Header: 'Device',
                        id: 'device_info',
                        accessor: ({ device_info }) => (
                            <span>{device_info?.os?.name || '—'}</span>
                        ),
                        minWidth: 60,
                        maxWidth: 60,
                        textAlign: 'start',
                    },
                    {
                        Header: 'Location',
                        id: 'location_info',
                        accessor: ({ location_info }) => {
                            if (location_info && location_info.status === 'success') {
                                return this.setUserLocation(location_info);
                            }
                            return <span>{t("Couldn't detect location")}</span>;
                        },
                        minWidth: 120,
                        maxWidth: 120,
                        textAlign: 'start',
                    },
                ]}
                requestData={(params) => userStore.get2FAHistory(userId, params)}
            />
        );
    }
}

export default inject('userStore', 'commonStore')(withLocalization(observer(TwoFactorHistoryList)));
